import React, { useEffect } from 'react';
import ProjectWizardOps from './projectwizardops';

export const ProjectWizardDevopsDialog = (props: any) => {
  useEffect(() => {
    // props.getEntity(props.match.params.id);
  }, []);

  const handleClose = () => {
    props.history.push('/project/');
  };

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  return <ProjectWizardOps finishEvent={props.createEntity} />;
};
